/**
 * 运营
 */

import Layout from '@/layout/Layout.vue'

export default {
  path: '/operation',
  name: '运营',
  component: Layout,
  redirect: '/operation/copywriting',
  children: [
    {
      path: 'copywriting',
      name: '文案',
      component: () => import('@/views/operation/copywriting/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'operation_copywriting'
      }
    },
    {
      path: 'email',
      name: '邮件',
      component: () => import('@/views/operation/email/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'operation_email'
      }
    },
    {
      path: 'Promotion/list',
      name: '活动列表',
      component: () => import('@/views/operation/Promotion/list/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'operation_promotionList'
      }
    },
    {
      path: 'Promotion/add',
      name: '新增促销活动',
      component: () => import('@/views/operation/Promotion/add/Index.vue'),
      meta: {
        father: {
          name: '促销活动',
          path: '/operation/Promotion/list'
        }
      }
    },
    {
      path: 'newFunction/list',
      name: '新功能站内信列表',
      component: () => import('@/views/operation/newFunction/list/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'operation_newFunction'
      }
    },
    {
      path: 'newFunction/add',
      name: '新功能站内信新增编辑',
      component: () => import('@/views/operation/newFunction/add/Index.vue'),
      meta: {
        father: {
          name: '新功能站内信列表',
          path: '/operation/newFunction/list'
        }
      }
    },
    // {
    //   path: 'Promotion/list',
    //   name: '促销活动',
    //   component: () => import('@/views/operation/Promotion/list/Index.vue')
    // },
    {
      path: 'bannerManage',
      name: 'banner管理',
      component: () => import('@/views/operation/bannerManage/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'operation_bannerManage'
      }
    },
    {
      path: 'promoCode',
      name: '优惠码',
      component: () => import('@/views/operation/promoCode/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'operation_promoCode'
      }
    },
    {
      path: 'promoCode/detail',
      name: '数据明细',
      component: () => import('@/views/operation/promoCode/Detail.vue'),
      meta: {
        father: {
          name: '优惠码',
          path: '/operation/promoCode'
        }
      }
    },
    {
      path: 'recharge',
      name: '充值',
      component: () => import('@/views/operation/recharge/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'operation_recharge'
      }
    },
    {
      path: 'advertisingBar',
      name: '广告栏配置',
      component: () => import('@/views/operation/advertisingBar/index.vue')
    },
    {
      path: 'advertisingPopups',
      name: '广告弹窗',
      component: () => import('@/views/operation/advertisingPopups/index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'operation_advertisingPopups'
      }
    },
    {
      path: 'advertisingPopups/add',
      name: '新增广告弹窗',
      component: () => import('@/views/operation/advertisingPopups/components/add.vue'),
      meta: {
        father: {
          name: '广告弹窗',
          path: '/operation/advertisingPopups'
        }
      }
    },
    {
      path: 'introduce',
      name: '猜你喜欢',
      component: () => import('@/views/operation/introduce/index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'operation_introduce'
      }
    },
    {
      path: 'hotsearch',
      name: '热搜词',
      component: () => import('@/views/operation/hotsearch/index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'operation_hotsearch'
      }
    },
    {
      path: 'customNav',
      name: '自定义导航',
      component: () => import('@/views/operation/customNav/index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'operation_customNav'
      }
    },
    {
      path: 'coupon',
      name: '优惠券',
      component: () => import('@/views/operation/coupon/index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'operation_coupon'
      }
    },
    {
      path: 'coupon/couponInfo',
      name: '优惠券信息',
      component: () => import('@/views/operation/coupon/components/CouponInfo.vue'),
      meta: {
        father: {
          name: '优惠券',
          path: '/operation/coupon'
        }
      }
    },
    {
      path: 'customer',
      name: '客户优惠券',
      component: () => import('@/views/operation/customer/index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'operation_customer'
      }
    },
    {
      path: '/operation/launchProduct',
      name: '推新配置管理',
      component: () => import('@/views/operation/launchProduct/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'operation_launchProduct'
      }
    },
  ],
}